import { NavTreeItem } from "../../../components/common/navigation";

// Client-side pre-filter for the merged FAQ tree — keeps a node if its own label
// matches (subtree kept as-is) or any descendant's label matches (pruned to matches only).
export const filterFaqNavTree = (items: NavTreeItem[], query: string): NavTreeItem[] => {
    const trimmed = query.trim().toLowerCase();
    if (!trimmed) {
        return items;
    }

    const filterItem = (item: NavTreeItem): NavTreeItem | null => {
        if (item.label.toLowerCase().includes(trimmed)) {
            return item;
        }

        const filteredChildren = (item.children ?? [])
            .map(filterItem)
            .filter((child): child is NavTreeItem => child !== null);

        if (filteredChildren.length === 0) {
            return null;
        }

        return { ...item, children: filteredChildren };
    };

    return items.map(filterItem).filter((item): item is NavTreeItem => item !== null);
};
